import {
  useCallback,
  createContext,
  useContext,
  useMemo,
  useState,
} from 'react';

type CardDndContextProps = {
  setReorderMode: (profileId: number, on: boolean) => void;
  reorderOnForProfile: (profileId: number) => boolean;
};

const CardDndToggleContext = createContext<CardDndContextProps>({
  setReorderMode: (profileId: number, on: boolean) => {},
  reorderOnForProfile: (profileId: number) => false,
});

const useCardDndToggle = () => {
  const [reorderOn, setReorderOn] = useState(new Map<number, boolean>());

  const setReorderMode = useCallback(
    (profileId: number, on: boolean) => {
      setReorderOn((prev) => {
        const newState = new Map(prev);
        newState.set(profileId, on);

        return newState;
      });
    },
    [setReorderOn],
  );

  const reorderOnForProfile = useCallback(
    (profileId: number) => Boolean(reorderOn.get(profileId)),
    [reorderOn],
  );

  return useMemo(
    () => ({
      setReorderMode,
      reorderOnForProfile,
    }),
    [setReorderMode, reorderOnForProfile],
  );
};

export const CardDndToggleProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const value = useCardDndToggle();

  return (
    <CardDndToggleContext.Provider value={value}>
      {children}
    </CardDndToggleContext.Provider>
  );
};

export const useCardDndToggleContext = () => useContext(CardDndToggleContext);
